module.exports = __webpack_public_path__ + "static/media/4-5.ca198d20.webp";